import { render, staticRenderFns } from "./TheUpdater.vue?vue&type=template&id=6e594b3e&"
import script from "./TheUpdater.vue?vue&type=script&lang=js&"
export * from "./TheUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports